
import db from '../Firestore.js';
import React, {
    useState,
    useEffect,
} from 'react';

import GamePreview from './GamePreview.jsx';

function renderGame(game, readOnly) {
    return (
        <GamePreview
            key={game.id}
            gameSnap={game}
            readOnly={readOnly}
        />
    );
}

export default function GameListing(props) {
    const {
        readOnly
    } = props;

    const [games, setGames] = useState([]);

    useEffect(() => {
        const now = new Date();
        const limitDate = new Date(+now + 4 * 24 * 60 * 60 * 1000);
        db.collection('games')
            .where('open', '==', true)
            .where('start_time', '<', limitDate)
            .orderBy('start_time')
            .limit(16)
            .get()
            .then((querySnap) => {
                setGames(querySnap.docs);
            });
    }, []);

    const renderGamePreviews = () => {
        return games.map( (game) => {
            return renderGame(game, readOnly);
        });
    };

    if (games.length === 0) {
        return (
            <h4> No Games To Display </h4>
        );
    }

    return (
        <div className="game-listing" >
            {renderGamePreviews()}
        </div>
    );
}

GameListing.defaultProps = {
    readOnly: false,
};
